/*
  TotalVet homepage: "Real Words from Pet Parents" carousel (sections/tv-home-reviews.liquid).
  Port of initTestimonialCarousel() in the WP theme's assets/js/custom/homepage_v3.js:
  3 cards per view above 768px and 1 at or below, moves one card at a time, one indicator per card,
  stops at the first/last card, re-measures on resize (250ms debounce).
*/
(() => {
  if (customElements.get('tv-home-reviews-carousel')) return;

  const GAP = 16;

  class TvHomeReviewsCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.dotsContainer = this.querySelector('[data-dots]');
      if (!this.viewport || !this.track || !this.prevButton || !this.nextButton) return;

      this.slides = Array.from(this.track.querySelectorAll('[data-slide]'));
      if (this.slides.length === 0) return;

      this.index = 0;
      this.perView = this.getPerView();

      this.onPrev = () => this.goTo(this.index - 1);
      this.onNext = () => this.goTo(this.index + 1);
      this.onResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          const perView = this.getPerView();
          if (perView !== this.perView) {
            this.perView = perView;
            this.index = Math.min(Math.max(this.index, 0), this.slides.length - 1);
            this.renderDots();
          }
          this.update();
        }, 250);
      };
      this.onBlockSelect = (event) => {
        const slide = event.target.closest('[data-slide]');
        const slideIndex = this.slides.indexOf(slide);
        if (slideIndex > -1) this.goTo(slideIndex);
      };

      this.prevButton.addEventListener('click', this.onPrev);
      this.nextButton.addEventListener('click', this.onNext);
      window.addEventListener('resize', this.onResize);
      this.addEventListener('shopify:block:select', this.onBlockSelect);

      this.renderDots();
      this.update();
      this.settleTimer = setTimeout(() => this.update(), 100);
    }

    disconnectedCallback() {
      if (!this.onResize) return;
      window.removeEventListener('resize', this.onResize);
      this.prevButton.removeEventListener('click', this.onPrev);
      this.nextButton.removeEventListener('click', this.onNext);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      clearTimeout(this.resizeTimer);
      clearTimeout(this.settleTimer);
    }

    getPerView() {
      return window.innerWidth <= 768 ? 1 : 3;
    }

    getCardWidth() {
      return (this.viewport.offsetWidth - GAP * (this.perView - 1)) / this.perView;
    }

    goTo(index) {
      if (index < 0 || index > this.slides.length - 1) return;
      this.index = index;
      this.update();
    }

    update() {
      const offset = -(this.index * (this.getCardWidth() + GAP));
      this.track.style.transform = `translateX(${offset}px)`;
      this.updateDots();
    }

    renderDots() {
      if (!this.dotsContainer) return;
      this.dotsContainer.innerHTML = '';
      this.dotsContainer.style.setProperty('--dots', this.slides.length);
      this.slides.forEach((slide, slideIndex) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'tv-home-reviews__dot';
        dot.setAttribute('aria-label', `Slide ${slideIndex + 1}`);
        dot.addEventListener('click', () => this.goTo(slideIndex));
        this.dotsContainer.appendChild(dot);
      });
      this.updateDots();
    }

    updateDots() {
      if (!this.dotsContainer) return;
      Array.from(this.dotsContainer.children).forEach((dot, dotIndex) => {
        const active = dotIndex === this.index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }
  }

  customElements.define('tv-home-reviews-carousel', TvHomeReviewsCarousel);
})();
